import { Table } from "react-bootstrap";
import { SortedTh } from "../Abstractions/SortedTh";
import { UpdateWeightDifference } from "../../useCases/weightDifferences/UpdateWeightDifference";
import { StatusBadge } from "../Abstractions/StatusBadge";

export function WeightDifferencesTable({ items, sorting, itemActions }) {
  const columnsNames = {
    name: "Nazwa"
  };

  return (
    <Table hover>
      <thead>
      <tr>
        {Object.entries(columnsNames).map(([value, name]) => (
          <SortedTh key={value} sorting={sorting} itemActions={itemActions} sortingValue={value}>
            {name}
          </SortedTh>
        ))}
        <th>Status</th>
        <th>Akcje</th>
      </tr>
      </thead>
      <tbody>
        {items?.loading && <tr className="spinner-border"></tr>}
        {items?.length > 0 &&
          items.map((item, index) => (
            <tr key={index}>
              <td style={{ width: "40%" }}>{item.name}</td>
              <td>
                <StatusBadge isActive={item.isActive}/>
              </td>
              <td>
                <UpdateWeightDifference item={item}/>
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );
}
